import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { Typography } from '@/components/shared/Typography';
import { CaseStudyTagCategory, CaseStudyTagDto } from '@/types/case-studies';
import css from './style.module.scss';
interface Props {
  tags: CaseStudyTagDto[];
}
const Tags: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    tags
  } = t0;
  if (!tags?.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [CaseStudyTagCategory.SERVICE, CaseStudyTagCategory.INDUSTRY];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const categoryOrder = t1;
  let t2;
  if ($[1] !== tags) {
    t2 = categoryOrder.flatMap(category => tags.filter(tag => tag.category === category && tag.name));
    $[1] = tags;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const orderedTags = t2;
  if (!orderedTags.length) {
    return null;
  }
  let t3;
  if ($[3] !== orderedTags) {
    t3 = <ul className={css.tags}>{orderedTags.map(_temp)}</ul>;
    $[3] = orderedTags;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Tags;
function _temp(tag_0) {
  return <Typography key={tag_0.id} variant="body-s" tag="li" className={css.tag}>{tag_0.name}</Typography>;
}